var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrapicDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 5,
    fill: "#F89C1C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7366 14.125H28.3199C27.1441 14.125 26.1949 15.0742 26.1949 16.25V17.6667C26.1949 18.8425 27.1441 19.7917 28.3199 19.7917H29.7366C30.9124 19.7917 31.8616 18.8425 31.8616 17.6667V16.25C31.8616 15.0742 30.9124 14.125 29.7366 14.125Z",
    fill: "url(#paint0_linear_1403_2723)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0491 27.1157H16.6324C15.4566 27.1157 14.5074 28.0649 14.5074 29.2407V30.6574C14.5074 31.8332 15.4566 32.7824 16.6324 32.7824H18.0491C19.2249 32.7824 20.1741 31.8332 20.1741 30.6574V29.2407C20.1741 28.0649 19.2108 27.1157 18.0491 27.1157Z",
    fill: "url(#paint1_linear_1403_2723)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3675 27.1157H39.9508C38.775 27.1157 37.8258 28.0649 37.8258 29.2407V30.6574C37.8258 31.8332 38.775 32.7824 39.9508 32.7824H41.3675C42.5433 32.7824 43.4925 31.8332 43.4925 30.6574V29.2407C43.4925 28.0649 42.5433 27.1157 41.3675 27.1157Z",
    fill: "url(#paint2_linear_1403_2723)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3125 28.8866C16.7317 28.8866 16.25 28.405 16.25 27.8241C16.25 21.775 20.7833 16.6891 26.79 15.9808C27.3567 15.9241 27.895 16.3349 27.9658 16.9158C28.0367 17.4966 27.6117 18.0208 27.0308 18.0916C22.1008 18.6725 18.375 22.8516 18.375 27.8241C18.375 28.405 17.8933 28.8866 17.3125 28.8866Z",
    fill: "url(#paint3_linear_1403_2723)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6875 28.8866C40.1067 28.8866 39.625 28.4049 39.625 27.8241C39.625 22.8799 35.9275 18.7008 31.0258 18.1058C30.445 18.035 30.0342 17.5108 30.105 16.9299C30.1758 16.3491 30.7141 15.9383 31.295 16.0092C37.2591 16.7317 41.7641 21.8175 41.7641 27.8383C41.75 28.405 41.2825 28.8866 40.6875 28.8866Z",
    fill: "url(#paint4_linear_1403_2723)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8275 43.1809H27.1867C25.8833 43.1809 24.92 42.1325 25.1608 40.9992L25.7558 38.3784H32.2583L32.8533 40.9992C33.1225 42.2034 32.2158 43.1809 30.8275 43.1809Z",
    fill: "url(#paint5_linear_1403_2723)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.7659 36.1542L32.2583 38.3784H25.7559L23.2483 36.1542C21.7892 34.9642 21.7892 34.0434 22.8942 32.6409L27.3142 27.0592C27.6258 26.6767 27.98 26.4076 28.3625 26.2801C28.7734 26.1384 29.2267 26.1384 29.6375 26.2801C30.02 26.4217 30.3742 26.6767 30.6858 27.0592L35.1058 32.6409C36.2108 34.0434 36.1684 34.9217 34.7659 36.1542Z",
    fill: "url(#paint6_linear_1403_2723)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 57.5,
    height: 57.5,
    rx: 4.75,
    stroke: "#2A85FF",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1403_2723",
    x1: 27.6364,
    y1: 15.0181,
    x2: 34.5601,
    y2: 19.0142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1403_2723",
    x1: 15.9489,
    y1: 28.0088,
    x2: 22.8726,
    y2: 32.0049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1403_2723",
    x1: 39.2673,
    y1: 28.0088,
    x2: 46.191,
    y2: 32.0049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1403_2723",
    x1: 19.2322,
    y1: 18.0103,
    x2: 34.2133,
    y2: 25.8618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1403_2723",
    x1: 33.0649,
    y1: 18.0319,
    x2: 47.9921,
    y2: 25.8329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1403_2723",
    x1: 27.102,
    y1: 39.1353,
    x2: 33.8632,
    y2: 45.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1403_2723",
    x1: 25.6095,
    y1: 28.0972,
    x2: 41.3627,
    y2: 38.3607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrapicDesign);
export default __webpack_public_path__ + "static/media/grapic-design.17d692b352bd29d587320745a6190e4c.svg";
export { ForwardRef as ReactComponent };